export default __webpack_public_path__ + "static/media/agencyVentura.ee6aa90b.png";